module.exports = __webpack_public_path__ + "static/img/success-withdraw-icon.10ce7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/success-withdraw-icon.png
// module id = 2wY3
// module chunks = 215